import i18n from '@/i18n';

const varOriginLabel = 'original_label_';
const varColumnIndex = 'column_index_content_';

const TYPE_PRIZE = [
    {
        id: 2,
        name: '現物'
    },
    {
        id: 1,
        name: 'デジタル賞品'
    }
];

const CONFIG_TABLE_PRIZE_SERIAL_CODE = {
    headers: [
        { label: '賞品名', width: 200 },
        { label: '画像', width: 150 },
        { label: '種別', width: 100 },
        { label: '当選確率', width: 100 },
        { label: '当選時間', width: 100 },
        { label: '現在の当選確率', width: 120 },
        { label: '総当選数', width: 100 },
        { label: '当選数', width: 100 },
        { label: '残数', width: 100 }
    ]
};

const LIST_NOTE_IMPORT_PRODUCT_CODE = [
    {
        label: '賞品コードおよびURLは、いずれも文字数制限なくアップロード可能です。'
    },
    {
        label: '空白は不可で、英字は大文字／小文字を区別します。'
    },
    {
        label: '賞品コードは重複チェックの対象となりますが、URLは対象外です。'
    },
    {
        label: 'テンプレートの「賞品コード」の名称は変更できません。それ以外の列名は自由に設定可能です。'
    },
    {
        label: '1行目に必ず列名を登録してください。1行目がブランクの場合、取り込みできません。'
    }
];

const CONFIG_TABLE_DIGITAL_GIF = () => {
    return {
        headers: []
    };
};

const configModalCreateOrEditPrize = () => {
    return {
        id: '',
        title: '',
        model: false,
        scrollable: true,
        hideFooter: false,
        class: 'h-100',
        size: 'xl',
        validate: true
    };
};

const initInputPrizeEventDate = (data = null) => {
    return {
        daily_limits: data?.daily_limits ?? []
    };
};

const initFormPrizeSerial = (data = null) => {
    return {
        title: data?.title ?? '',
        image: data?.image ?? null,
        width_image: data?.width_image ?? '',
        height_image: data?.height_image ?? '',
        prize_type: data?.prize_type ?? TYPE_PRIZE[0].id,
        number_in_kind: data?.number_in_kind ?? '',
        header_lottery: data?.header_lottery ?? '',
        body_lottery: data?.body_lottery ?? '',
        footer_lottery: data?.footer_lottery ?? '',
        header_rejection: data?.header_rejection ?? '',
        body_rejection: data?.body_rejection ?? '',
        footer_rejection: data?.footer_rejection ?? '',
        blocks: data?.blocks ?? [],
        probability_of_winning: (data?.probability_of_winning ?? null) !== null ? Number(data?.probability_of_winning) : null,
        list_product_import: data?.list_product_import ?? [],
        prize_date_event: initInputPrizeEventDate(data?.prize_date_event),
        start_time_winning: data?.start_time_winning ?? null,
        end_time_winning: data?.end_time_winning ?? null,
        won_count: data?.won_count ?? null,
        remaining_count: data?.remaining_count ?? null,
        current_probability: data?.current_probability ?? null,
        setting_buttons: data?.setting_buttons ?? {
            label_btn_register: '賞品受取フォームへ',
            img_btn_register: null
        },
        extension: {
            aspect_ratio: data?.extension?.aspect_ratio ? Number(data?.extension?.aspect_ratio) : null,
            is_lock_ratio: data?.extension?.is_lock_ratio ?? true,
            is_selected: data?.extension?.is_selected ?? false
        }
    };
};

const configFormPrizeSerial = () => {
    return {
        title: {
            errorField: i18n.t('managerForm.settingSerialCode.titleSerialCode'),
            error: false,
            typesValidate: ['required', 'max255']
        },
        number_in_kind: {
            isNumber: true,
            errorField: i18n.t('managerForm.settingSerialCode.numberInKind'),
            error: false,
            maxlength: 5,
            typesValidate: ['required']
        },
        probability_of_winning: {
            errorField: i18n.t('managerForm.settingSerialCode.probabilityofWinning'),
            error: false,
            min: 0,
            max: 100,
            typesValidate: ['required', 'number-range']
        },
        width_image: {
            isNumber: true,
            min: 1,
            max: 800,
            maxlength: 10,
            errorField: i18n.t('managerForm.settingSerialCode.widthImage'),
            error: false,
            typesValidate: []
        },
        height_image: {
            isNumber: true,
            maxlength: 10,
            errorField: i18n.t('managerForm.settingSerialCode.heightImage'),
            error: false,
            typesValidate: []
        }
    };
};

const normalizeLabelKey = (label) =>
    String(label)
        .trim()
        .replace(/[^a-zA-Z0-9_]/g, '_');

const buildHeaders = (data) => {
    const labelMap = new Map();
    let startIndexLabelContent = 2;
    data.forEach((item) => {
        item.contents?.forEach((c) => {
            if (c?.label !== null && c?.label !== undefined) {
                const label = String(c.label).trim();
                const colIndex = c.column_index ?? 0;
                if (!labelMap.has(label) || labelMap.get(label) > colIndex) {
                    labelMap.set(label, colIndex);
                }
            }
        });
    });

    const sortedLabels = [...labelMap.entries()].sort((a, b) => a[1] - b[1]).map((entry) => entry[0]);

    return [
        { label: '{$1} = 賞品コード', key: 'code', width: 200 },
        ...sortedLabels.map((label, idx) => ({
            label: `{$${startIndexLabelContent + idx}} = ${label}`,
            key: `content_${normalizeLabelKey(label)}`,
            width: 200
        })),
        { label: '済', key: 'done', width: 80 }
    ];
};

const mapTableData = (data) => {
    return data.map((item) => {
        const row = {
            ...(item?.id !== null && item?.id !== undefined && { id: item?.id }),
            code: item.code,
            done: item.done
        };
        item.contents?.forEach((c) => {
            if (c?.label === null || c?.label === undefined) return;
            const labelKey = normalizeLabelKey(c.label);
            if (c?.id !== null && c?.id !== undefined) {
                row[`id_content_${labelKey}`] = c.id;
            }
            row[`${varColumnIndex}${labelKey}`] = c.column_index;
            row[`${varOriginLabel}${labelKey}`] = c.label;
            row[`content_${labelKey}`] = c.content ?? '';
        });
        return row;
    });
};

const unflattenItem = (row) => {
    const result = {
        ...(row?.id !== null && row?.id !== undefined && { id: row?.id }),
        code: row?.code ?? '',
        done: row?.done ?? 0,
        contents: []
    };
    Object.keys(row || {})
        .filter((k) => k.startsWith('content_'))
        .forEach((k) => {
            const labelKey = k.replace('content_', '');
            const value = row[k];
            if (value === undefined || value === '') return;
            const originalLabel = row[`${varOriginLabel}${labelKey}`] || labelKey;
            result.contents.push({
                ...(row[`id_content_${labelKey}`] !== null &&
                    row[`id_content_${labelKey}`] !== undefined && {
                        id: row[`id_content_${labelKey}`]
                    }),
                label: originalLabel?.toString(),
                content: value?.toString(),
                column_index: row[`${varColumnIndex}${labelKey}`]
            });
        });
    return result;
};

const processBodyLottery = (bodyParam) => {
    bodyParam = bodyParam.replace(/\{\$[^}]*\}/g, '');
    let result = bodyParam;
    const divRegex = /<div[^>]*>([\s\S]*?)<\/div>/gi;
    let match;
    const replacements = [];
    while ((match = divRegex.exec(bodyParam)) !== null) {
        const fullMatch = match[0];
        const innerContent = match[1];
        const cleanedContent = innerContent.replace(/<\/?br[^>]*>/gi, '').trim();
        if (!cleanedContent) {
            replacements.push({ from: fullMatch, to: '' });
        } else {
            const newContent = innerContent.replace(/(<\/?br[^>]*>\s*){2,}/gi, '</br>');
            replacements.push({ from: fullMatch, to: `<div>${newContent}</div>` });
        }
    }
    replacements.forEach((replacement) => {
        result = result.replace(replacement.from, replacement.to);
    });
    bodyParam = result;
    return bodyParam;
};

const onHandleMapColumnIndex = (headers) => {
    return (headers || [])
        .map((item) => {
            const match = item.label?.match(/\{\$(\d+)\}/);
            return match ? Number(match[1]) : null;
        })
        .filter((val) => val !== null);
};

const validateMaxDecimals = (value, decimalPlaces = 2) => {
    const strValue = String(value).trim();
    if (strValue === '') return true;
    const regexString = `^-?\\d+(\\.\\d{1,${decimalPlaces}})?$`;
    const regex = new RegExp(regexString);
    return regex.test(strValue);
};

const getMaxColumnIndex = (data) => {
    const allIndexes = (data || [])
        .flatMap((item) => item.contents || [])
        .map((content) => content.column_index)
        .filter((index) => typeof index === 'number');

    return allIndexes.length > 0 ? Math.max(...allIndexes) : 0;
};

const getLabels = (data, objCondition = { key: 'content', separator: ' = ' }) => {
    return (data || [])
        .filter((item) => item.key && item.key.includes(objCondition.key))
        .map((item) => {
            const parts = item.label.split(objCondition.separator);
            return parts.length > 1 ? parts[1].trim() : String(item.label).trim();
        });
};

export {
    CONFIG_TABLE_PRIZE_SERIAL_CODE,
    TYPE_PRIZE,
    LIST_NOTE_IMPORT_PRODUCT_CODE,
    configModalCreateOrEditPrize,
    CONFIG_TABLE_DIGITAL_GIF,
    initFormPrizeSerial,
    configFormPrizeSerial,
    buildHeaders,
    mapTableData,
    unflattenItem,
    initInputPrizeEventDate,
    processBodyLottery,
    onHandleMapColumnIndex,
    validateMaxDecimals,
    getMaxColumnIndex,
    getLabels
};
